module.exports={Announcements:"公告",MarkAllAsRead:"将所有提醒标记为已读",NoLinkNotification:"没有此通知的链接",Notification:"通知",ViewAll:"查看所有"};